module.exports = __webpack_public_path__ + "static/football-d6cc48ff7e49e9f4be6b3c68e1caadfb.jpg";